<template>
  <div class="tag-padding">
  <div class="add-title">
    {{ getDisplayTitle }}
  </div>
  <div class="add-line" v-if="!this.RMTStore.manageGroupMode">
    <div class="line-title">
      name
    </div>
    <input
        ref="tagName"
        type="text"
        class="add-tag-input"
        :value="getNameValue"
        @focus="handleNameFocus"
    >
  </div>
  <div class="add-line line-up">
    <div class="line-title" v-if="!this.RMTStore.manageGroupMode">
      group
    </div>
    <div class="group-selection-holder">
      <div class="selected-option" v-if="!this.RMTStore.manageGroupMode">
        <KeywordOption
            v-if="selectedTagAddGroup !== null"
            :option="selectedTagAddGroup"
            :removable="true"
            @click="deselectOptionAsGroup"
        />
      </div>
      <div
          ref="groupOptionHolder"
          v-if="!showAddGroup"
          class="group-option-holder"
      >
        <div class="select-label">
          Select a group
        </div>
        <!-- replace with groups not tag names -->
        <KeywordOption
            v-for="(option, index) in groupData"
            :key="index"
            :option="option"
            :removable="false"
            :type="'group'"
            @click="selectOptionAsGroup(option)"
        />
        <div
            v-if="!showAddGroup"
            class="add-group-btn"
            @click="handleAddGroup"
        >
          + Add Group
        </div>
      </div>
      <div
          v-if="!showAddGroup"
          class="manage-groups-btn"
          @click="handleManageGroup"
      >
        {{ showManageText }}
      </div>
    </div>
  </div>
  </div>
  <div class="feedback" v-if="message.length > 0">{{ message }}</div>
  <RightPanelButtons :save="handleSaveTag" :cancel="handleCancelAddTag"/>
</template>

<script>
import {useRMTStore} from '@/store/RMTStore';
import {mapStores, storeToRefs} from 'pinia/dist/pinia';
import KeywordOption from '@/components/rmt/KeywordOption';
import RightPanelButtons from '@/components/rmt/RightPanelButtons';
import {useTagStore} from '@/store/TagStore';
import {nextTick} from 'vue';

export default {
  name: 'CreateTag',
  components: {
    KeywordOption,
    RightPanelButtons
  },
  data () {
    return {
      message: ''
    };
  },
  setup () {
    const RMTStore = useRMTStore();
    const { selectedTagAddGroup } = storeToRefs(RMTStore);
    const TagStore = useTagStore();
    const { groupData } = storeToRefs(TagStore);
    return {
      RMTStore, selectedTagAddGroup, TagStore, groupData
    };
  },
  watch: {
    editTag (to) {
      this.$refs.tagName.value = (this.editTag === null) ? '' : to.tag;

    },
    editGroup (to) {
      nextTick(() => {
        this.$refs.groupName.value = (this.RMTStore.editGroup === null) ? '' : to.groupName;
      });
    },
    selectedTagAddGroup () {
      if (this.selectedTagAddGroup === null) {
        this.selectOptionAsGroup(this.groupData[0]);
      }
    },
    groupData () {
      this.RMTStore.selectedTagAddGroup = this.TagStore.groupData[this.TagStore.groupData.length-1];
    },
  },
  computed: {
    ...mapStores(useRMTStore),
/*    selectedTagAddGroup: {
      get () {
        const RMTStore = useRMTStore();
        return RMTStore.selectedTagAddGroup;
      },
      set (value) {
        const RMTStore = useRMTStore();
        RMTStore.selectedTagAddGroup = value;
      }
    },*/
    showAddGroup () {
      const RMTStore = useRMTStore();
      return RMTStore.showAddGroup;
    },
    groupData () {
      const RMTStore = useRMTStore();
      return RMTStore.groupData;
    },
    showManageText () {
      return ''; // (!this.RMTStore.manageGroupMode) ? 'Manage Groups' : 'Done Managing Groups';
    },
    getDisplayTitle () {
      return (this.RMTStore.manageGroupMode) ? 'MANAGE GROUPS' : (this.RMTStore.matrixMode === 'add') ? 'CREATE TAG' : 'EDIT TAG';
    },
    getNameValue () {

      return (this.RMTStore.matrixMode === 'edit') ? this.RMTStore.editTag.tag: '';
    }
  },
  methods: {
    handleNameFocus () {
      this.message = '';
    },
    deselectOptionAsGroup () {
      this.message = '';
      this.selectedTagAddGroup = null;
    },
    selectOptionAsGroup (option) {
      this.message = '';
      if (this.RMTStore.manageGroupMode) { return; }
      this.selectedTagAddGroup = option;
    },
    handleAddGroup () {
      this.RMTStore.editGroup = null;
      this.RMTStore.showAddGroup = !this.RMTStore.showAddGroup;
    },
    handleManageGroup () {
      this.RMTStore.manageGroupMode = !this.RMTStore.manageGroupMode;
    },
    handleCancelAddTag () {
      this.RMTStore.matrixMode = 'show';
      this.$refs.groupOptionHolder.scrollTop = 0;
    },
    handleSaveTag () {

      if (this.RMTStore.manageGroupMode) {
        this.handleCancelAddTag();
        return;
      }

      if (this.$refs.tagName.value === '') {
        this.message = 'Enter a tag name.';
        return;
      }

      if (this.selectedTagAddGroup === null) {
        this.message = 'Select a group.';
        return;
      }

      if (this.RMTStore.matrixMode === 'add') {
        this.RMTStore.createTag(
            {
              tag: this.$refs.tagName.value,
              color: '#ff0000',
              groupId: (this.selectedTagAddGroup !== null) ? this.selectedTagAddGroup.groupId : null
            }
        );
      }
      if (this.RMTStore.matrixMode === 'edit') {
        this.RMTStore.editTag.tag = this.$refs.tagName.value;
        this.RMTStore.editTag.groupId = (this.selectedTagAddGroup !== null) ? this.selectedTagAddGroup.groupId : null;
        this.RMTStore.updateTag(this.RMTStore.editTag);
      }
      this.handleCancelAddTag();
    },
  }
};
</script>

<style scoped>

.feedback {
/*  border: 2px solid #cb0101;*/
  padding: 4px;
  padding-left:8px;
  padding-right: 8px;
/*  margin-top: 10px;*/
  margin-right: 20px;
  margin-left: 20px;
  font-weight: 700;
  font-size: .85em;
  color: #cb0101;
}

.add-line {
  display: flex;
  align-items: center;
  justify-content: stretch;
  margin: 3px;
}
.line-up {
  align-items: flex-start;
}
.add-title {
  font-size: .8em;
  font-weight: 700;
}
.line-title {
  width: 25%;
  font-weight: 700;
  font-size: .9em;
}
.add-tag-input {
  width: 75%;
  height: 30px;
  background-color: #eeeeee;
  border-radius: 20px;
  padding: 10px;
  font-size: .85em;
}
.group-selection-holder {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
}
.group-option-holder {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
/*  overflow: hidden;*/
  border: 1px solid black;
  background-color: white;
  max-height: 170px;
  overflow: auto;
  padding: 4px;
}

.add-group-btn {
  background-color: #c0c0c0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 13px;
  border-radius: 15px;
  height: 30px;
  font-size: .80em;
  font-weight: 700;
  margin: 3px;
}
.add-group-btn:hover {
  background-color: #9a9a9a;
}

.selected-option {
  height: 46px;
  background-color: #efefef;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 4px;
  padding-left: 6px;
}

.select-label {
  font-size: .80em;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 10px;
}
.manage-groups-btn {
  font-size: .80em;
  font-weight: 700;
  margin-top: 7px;
}

.tag-padding {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}

</style>